export default __webpack_public_path__ + "static/media/nautilus8.1a47438f.jpg";